module.exports = __webpack_public_path__ + "nc_static/media/device_image.f075c045.jpg";